/* the size for summaryHeading (h2) is h4 from styleguide.css */

.questionHeader {
  min-height: 5em;
  padding-right: 0.5em;
}

.container {
  display: flex;
  flex-wrap: wrap;
}

.questionContainer {
  flex: 0 0 49%;
}
